module.exports = __webpack_public_path__ + "img/img1.f7383373.png";